import { UnsubscribeViewModel } from '../../../viewmodels/AppViewModels';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';
import { baseStyleSheet } from '../../../web/styles/styles';
import { styleSheet } from './styles';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import { parse } from 'query-string';
import * as React from 'react';

interface IUnsubscribeSearch {
	account: string;
	token: string;
	email: string;
}

/**
 * Example URL
 * https://localhost:3000/unsubscribe.html#/?account=Levitate&email=nick.beaulieu%40levitateapp.com&token=123abc
 */

export const UnsubscribeApp: React.FC = observer(() => {
	const { account, token, email }: IUnsubscribeSearch = parse(location.hash.replace('#/', ''));
	const unsubscribeVM = React.useRef(new UnsubscribeViewModel(account, token, email));

	const unsubscribe = React.useCallback(() => unsubscribeVM.current.unsubscribe(), []);
	const resubscribe = React.useCallback(() => unsubscribeVM.current.resubscribe(), []);

	return (
		<div className={css(styleSheet.container)}>
			{unsubscribeVM.current.isBusy ? (
				<div className={css(styleSheet.card)}>
					<LoadingSpinner type='large' />
				</div>
			) : !unsubscribeVM.current.isSubscribed ? (
				<div className={css(styleSheet.card)}>
					<div className={css(styleSheet.unsubscribeContainer)}>
						<div className={css(styleSheet.title, styleSheet.unsubscribedTitle)}>You are now unsubscribed</div>
						{unsubscribeVM.current.wasError && (
							<div className={css(styleSheet.error)}>
								Error connecting to Levitate. Please try again in a few minutes.
							</div>
						)}
						<button className={css(baseStyleSheet.ctaButton, styleSheet.resubscribeButton)} onClick={resubscribe}>
							<span>Resubscribe</span>
						</button>
					</div>
				</div>
			) : (
				<div className={css(styleSheet.card)}>
					<div className={css(styleSheet.title)}>Unsubscribe from this list</div>
					<div className={css(styleSheet.paragraph)}>
						By clicking the button below you will be unsubscribed from receiving all future emails from
						<span className={css(styleSheet.token)}>{unsubscribeVM.current.accountName}</span>.
					</div>
					<div className={css(styleSheet.paragraph)}>
						Email Address:
						<span className={css(styleSheet.token)}>{unsubscribeVM.current.email}</span>
					</div>
					{unsubscribeVM.current.wasError && (
						<div className={css(styleSheet.error)}>
							Error connecting to Levitate. Please try again in a few minutes.
						</div>
					)}
					<button className={css(baseStyleSheet.ctaButton)} onClick={unsubscribe}>
						<span>Unsubscribe</span>
					</button>
				</div>
			)}
		</div>
	);
});
